import { Component } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { Session } from '../models/Session';
import { Credentials } from '../models/Credentials';
import { AuthService } from '../services/auth.service';
import { BaseComponent } from '../base/base.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ManagerService } from '../services/manager.service';
import { Manager } from '../models/Manager';

@Component({
  selector: 'login',
  templateUrl: 'login.component.html',
  styleUrls: ['login.component.css']
})
export class LoginComponent extends BaseComponent {

  emailFormControl = new FormControl('', [Validators.required, Validators.email]);
  passwordFormControl = new FormControl('', [Validators.required]);
  
  constructor(public override snackBar: MatSnackBar, private router: Router, private authService: AuthService, private managerService: ManagerService) {
    super(snackBar);
  }

  ngOnInit() {
    if (this.managerService.getToken())
      this.router.navigate(['/main']);
  }

  showPassword: boolean = false;
  credentials: Credentials = {
    email: '',
    password: ''
  };
  
  formValid() {
    return this.emailFormControl.valid && this.passwordFormControl.valid;
  }

  login() {
    if (this.formValid()) {
      this.authService.authenticate(this.credentials).subscribe(
        session => {
          this.managerService.setToken((session as Session).accessToken);
          this.managerService.getMe().subscribe(
            user => {
              if (user) {
                this.managerService.setLoggedUser(user as Manager);
                this.router.navigate(['/main']);
              }
              else
                this.managerService.logout();
            },
            error => { this.showError(error, 'Get logged user has failed due to server error'); }
          );
        },
        error => { this.showError(error, 'Login has failed due to incorrect credentials'); }
      );
    }
  }

  cancel() {
    this.credentials.email = '';
    this.credentials.password = '';
  }
}